import { render, staticRenderFns } from "./remoteAssistance.vue?vue&type=template&id=dd82af0c&scoped=true&"
import script from "./remoteAssistance.vue?vue&type=script&lang=js&"
export * from "./remoteAssistance.vue?vue&type=script&lang=js&"
import style0 from "./remoteAssistance.vue?vue&type=style&index=0&id=dd82af0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd82af0c",
  null
  
)

component.options.__file = "remoteAssistance.vue"
export default component.exports